import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import ConditionRuleBuilder from "./condition_rule";
import { CaptureMultipleForm, CaptureDataForm } from "./capture_forms";
import RawJsonEditor from "./raw_rule_editor";
import { IconButton } from "./common_controls";
import { serializeRule, reclassifyRule } from "./config_model";

const KIND_LABEL = {
  CONDITION: "Rule",
  CAPTURE_MULTIPLE: "Auto-capture repeat submissions",
  CAPTURE_DATA: "Auto-capture referral leads",
  RAW: "Unrecognized rule (JSON only)"
};

const RuleCard = ({ index, rule, onChange, onRemove, onMoveUp, onMoveDown, knownColumns }) => {
  const [editAsJson, setEditAsJson] = useState(rule._kind === "RAW");

  const applyJson = parsed => onChange(reclassifyRule(rule, parsed));

  return (
    <div className="mb-3 border rounded bg-white shadow-sm overflow-hidden" style={{ borderRadius: 10, border: "1px solid #e2e8f0" }}>
      <Row noGutters className="align-items-center px-3 py-2 border-bottom" style={{ backgroundColor: "#f0f2f5" }}>
        <Col><span className="font-weight-bold text-dark">{index + 1}. {KIND_LABEL[rule._kind]}</span></Col>
        {rule._kind !== "RAW" && (
          <Col xs="auto" className="mr-3">
            <span className="small text-primary" style={{ cursor: "pointer" }} onClick={() => setEditAsJson(!editAsJson)}>
              {editAsJson ? "Edit as form" : "Edit as JSON"}
            </span>
          </Col>
        )}
        <Col xs="auto" className="mr-2 d-flex align-items-center">
          <IconButton icon="arrow_upward" onClick={onMoveUp} title="Move up" disabled={!onMoveUp} />
          <IconButton icon="arrow_downward" onClick={onMoveDown} title="Move down" disabled={!onMoveDown} />
        </Col>
        <Col xs="auto"><IconButton icon="delete" danger onClick={onRemove} title="Remove rule" /></Col>
      </Row>
      <div className="p-3 bg-white">
        {editAsJson ? (
          <RawJsonEditor value={serializeRule(rule)} onApply={applyJson} />
        ) : rule._kind === "CONDITION" ? (
          <ConditionRuleBuilder data={rule.data} onChange={data => onChange({ ...rule, data })} knownColumns={knownColumns} />
        ) : rule._kind === "CAPTURE_MULTIPLE" ? (
          <CaptureMultipleForm data={rule.data} onChange={data => onChange({ ...rule, data })} knownColumns={knownColumns} />
        ) : rule._kind === "CAPTURE_DATA" ? (
          <CaptureDataForm data={rule.data} onChange={data => onChange({ ...rule, data })} knownColumns={knownColumns} />
        ) : null}
      </div>
    </div>
  );
};

export default RuleCard;
